import styled from '@emotion/styled';
import { WidgetSizeEnum } from '@core/types';
/**
 * [CS-6259] Thumbnail container for medium carousel v2
 */
export const StyledThumbnailContainerV2 = styled.div `
  background: var(--thumbnail-background, #f5f5f5);
  ${({ thumbnailSize: size }) => {
    switch (size) {
        case 'small':
            return 'width: clamp(346px, 440px, 440px);';
        case 'medium':
            return 'width: clamp(338px, 482px, 482px);';
        default:
            return 'width: clamp(480px, 600px, 600px);';
    }
}}
  min-width: 0;
  border-radius: var(--border-radius);
  overflow: hidden;
  display: flex;
  margin-bottom: 6px;
  transition: box-shadow 0.15s ease-in;
  align-items: center;

  &:hover,
  &:focus-within {
    box-shadow: var(
      --thumbnail-hover-shadow,
      0px 4px 4px 0px rgba(0, 0, 0, 0.25)
    );
  }
`;
export const StyledThumbnailContainerV2Body = styled.div `
  font-weight: var(--thumbnail-font-weight, 400);
  font-size: var(
    --thumbnail-font-size,
    ${({ thumbnailSize: size }) => {
    switch (size) {
        case 'small':
            return '16px';
        case 'medium':
            return '14px';
        default:
            return '18px';
    }
}}
  );
  line-height: 18px;
  padding: 24px 24px 24px 20px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: ${({ thumbnailSize: size }) => size === WidgetSizeEnum.SMALL ? 'space-between' : 'space-evenly'};

  @media (min-width: 1024px) {
    font-size: var(
      --thumbnail-font-size,
      ${({ thumbnailSize: size }) => {
    switch (size) {
        case 'small':
            return '16px';
        case 'medium':
            return '16px';
        default:
            return '18px';
    }
}}
    );
    line-height: 20px;
    padding: 24px 32px 24px 24px;
  }
`;
export const StyledCaptionContainer = styled.div `
  height: 60px;
  display: flex;
  align-items: center;
`;
export const StyledCaption = styled.p `
  margin: 0;
  color: var(--thumbnail-caption-color, #000);
  display: -webkit-box;
  text-overflow: ellipsis;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  box-orient: vertical;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
export const StyledCTAContainer = styled.div `
  max-width: ${({ containerWidth }) => `calc(${containerWidth}px - 198px)`};
  @media (min-width: 1024px) {
    max-width: ${({ containerWidth }) => `calc(${containerWidth}px - 210px)`};
  }

  a {
    max-width: fit-content;
  }
`;
